export default "__VITE_ASSET__038054d2__"